import React, { useState } from 'react';
import { Link } from 'react-router-dom';

function SideNav() {
  let user;

  try {
    const userData = JSON.parse(localStorage.getItem('user'));
    user = userData;
  } catch (error) {
    console.error("Failed to parse user data from localStorage:", error);
    user = {
      profilePic: ".../images/logoimage.jpg",
      fullName: "Guest User",
      role: "guest",
    };
  }

  const commonMenus = [
    { name: "My Forms", path: "MyForms", color: "#3498DB" },
    { name: "Published Forms", path: "PublishedForms", color: "#E67E22" },
    { name: "Forms submitted to me", path: "FormsSubmitted", color: "#2ECC71" },
    { name: "Forms shared with me", path: "FormsShared", color: "#9B59B6" },
  ];

  const AdminMenu=[
    {name:"Dash Board",path:"admindashboard",color:"#72af79"}
  ]
  const formDesignerMenus = [
    { name: "Form Masters", path: "FormMasters", color: "#2ECC71" },
  ];

  const formApproverMenus = [
    { name: "Forms to Approve", path: "FormMastersForApprover", color: "#2ECC71" },
  ];

  const adminMenus = [
    { name: "Users", path: "Users", color: "#C0392B" },
    { name: "Form Categories", path: "FormCategories", color: "#2980B9" },
    { name: "Job Categories", path: "JobCategories", color: "#27AE60" },
    { name: "Settings", path: "Settings", color: "#F39C12" },
    { name: "Error Logs", path: "ErrorLogs", color: "#8E44AD" },
  ];

  const [openMenu, setOpenMenu] = useState(null);

  const toggleMenu = (menuName) => {
    setOpenMenu(openMenu === menuName ? null : menuName);
  };

  return (
    <div>
      <aside className="main-sidebar sidebar-dark-primary elevation-4">
        <a href="#" className="brand-link">
          <img
            src="http://innoapp.azurewebsites.net/Theme/my_images/innoease_favicon.png"
            alt="Innoease Solutions"
            className="brand-image img-circle elevation-3"
            style={{ opacity: '.8' }}
          />
          <span className="brand-text font-weight-light">Innoease Solutions</span>
        </a>
        <div className="sidebar">
          <div className="user-panel mt-3 pb-3 mb-3 d-flex">
            <div className="image">
              {user.profilePic ? (
                <img
                  src={user.profilePicBase64}
                  className="img-circle elevation-2"
                  alt="User Img"
                />
              ) : (
                <img
                  src="../images/user.jpg"
                  className="img-circle elevation-2"
                  alt="User Img"
                />
              )}
            </div>
            <div className="info">
              <a href="#" className="d-block">{user.fullName}</a>
            </div>
          </div>

          <nav className="mt-2">
            <ul className="nav nav-pills nav-sidebar flex-column" data-widget="treeview" role="menu">

              {/* Common Menus */}
 {user.isAdmin && AdminMenu.map((menu,index) => 
(
    <li key={index} className="nav-item">
      <Link
      to={`/editor/${menu.path.split('/').pop()}`}
      className="nav-link"
    >
      <i className="far fa-circle nav-icon" style={{ color: menu.color }} />
      <p>{menu.name}</p>
    </Link>
  </li>
))}
              {commonMenus.map((menu, index) => (
                <li key={index} className="nav-item">
                  <Link
                    to={`/editor/${menu.path.split('/').pop()}`}
                    className="nav-link"
                  >
                    <i className="far fa-circle nav-icon" style={{ color: menu.color }} />
                    <p>{menu.name}</p>
                  </Link>
                </li>
              ))}

              {/* Form Designer Direct Menu */}
{user.isFormDesigner && formDesignerMenus.map((menu, index) => (
  <li key={index} className="nav-item">
    <Link
      to={`/editor/${menu.path.split('/').pop()}`}
      className="nav-link"
    >
      <i className="far fa-circle nav-icon" style={{ color: menu.color }} />
      <p>{menu.name}</p>
    </Link>
  </li>
))}

{/* Form Approver Direct Menu */}
{user.isFormApprover && formApproverMenus.map((menu, index) => (
  <li key={index} className="nav-item">
    <Link
      to={`/editor/${menu.path.split('/').pop()}`}
      className="nav-link"
    >
      <i className="far fa-circle nav-icon" style={{ color: menu.color }} />
      <p>{menu.name}</p>
    </Link>
  </li>
))}


              {/* For Admin */}
              {user.isAdmin && (
                <li className={`nav-item has-treeview ${openMenu === "admin" ? "menu-open" : ""}`}>
                  <a
                    href="#"
                    className="nav-link"
                    onClick={e => {
                      e.preventDefault();
                      toggleMenu("admin");
                    }}
                  >
                    <i className="nav-icon fas fa-user-shield text-danger" />
                    <p>
                      Admin
                      <i className="right fas fa-angle-left" />
                    </p>
                  </a>
                  <ul className={`nav nav-treeview ${openMenu === "admin" ? "d-block" : "d-none"}`}>
                    {adminMenus.map((menu, index) => (
                      <li key={index} className="nav-item">
                        <Link
                          to={`/editor/${menu.path.split('/').pop()}`}
                          className="nav-link"
                        >
                          <i className="far fa-circle nav-icon" style={{ color: menu.color }} />
                          <p>{menu.name}</p>
                        </Link>
                      </li>
                    ))}
                  </ul>
                </li>
              )}

            </ul>
          </nav>
        </div>
      </aside>
    </div>
  );
}

export default SideNav;
